import styled from 'styled-components';
import media from '../../../constants/media';

export const Wrapper = styled.div``;

export const InputWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${media.mobileOnly`
		flex-wrap: wrap;
	`};
`;

export const TableWrapper = styled.div`
	margin-top: 2rem;
`;

export const LoaderContainer = styled.div`
	margin-top: 2rem;
`;

export const SeeMoreContainer = styled.div`
	text-align: center;
`;
